// Which greeting the app opens with, and whether it has already been shown.
// Kept free of React and of Date.now() so the boundaries (11:00, 17:00,
// midnight) can be tested directly.

export type DayPart = 'morning' | 'afternoon' | 'evening';

/** Nastavenia -> Privítanie pri otvorení. */
export type GreetingMode = 'parts' | 'daily' | 'off';

const MORNING_UNTIL_HOUR = 11;
const EVENING_FROM_HOUR = 17;

export const dayPart = (date: Date): DayPart => {
  const hour = date.getHours();
  if (hour < MORNING_UNTIL_HOUR) {
    return 'morning';
  }
  return hour < EVENING_FROM_HOUR ? 'afternoon' : 'evening';
};

const TITLE: Record<DayPart, string> = {
  morning: 'Dobré ráno',
  afternoon: 'Ahoj',
  evening: 'Dobrý večer',
};

export const greetingTitle = (part: DayPart, name: string | null | undefined): string => {
  const first = (name ?? '').trim().split(/\s+/)[0];
  return first ? `${TITLE[part]}, ${first}` : TITLE[part];
};

/** Local calendar day — the app's day starts at local midnight, not UTC. */
export const dayKey = (date: Date): string => {
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * The slot a greeting belongs to. Storing the slot (rather than a timestamp)
 * is what makes "once per part of the day" and "once per day" the same code.
 */
export const greetingSlot = (date: Date, mode: GreetingMode): string =>
  `${dayKey(date)}:${mode === 'daily' ? 'day' : dayPart(date)}`;

export const shouldGreet = (
  mode: GreetingMode,
  now: Date,
  storedSlot: string | null,
): boolean => mode !== 'off' && greetingSlot(now, mode) !== storedSlot;
